import {Component, Input} from "@angular/core";
import {SearchFormExtendedService} from "../../../entity/search/search-form/search-form-extended.service";

@Component({
    selector: "wbo-bi-filter-page",
    styleUrls: ["./filter-page.component.scss"],
    templateUrl: "./filter-page.component.html",
    providers: [SearchFormExtendedService]
})
export class FilterPageComponent {
    /**
     * Title override.
     */
    @Input() title: string;

}
